export default [
  {
    label: "Ações",
    visible: false,
    key: null,
    tooltip: null,
  },
  {
    label: "Nome",
    visible: true,
    key: "strategy_name",
    tooltip: "Nome da estratégia",
  },
  {
    label: "Ativo",
    visible: true,
    key: "strategy_symbol",
    tooltip: "Ativo operado pela estratégia",
  },
  {
    label: "TF",
    visible: true,
    key: "strategy_timeframe",
    tooltip: "Timeframe",
    optional: true,
    active: true,
  },
  {
    label: "Posição",
    visible: true,
    key: "position_status",
    tooltip: "Status da posição",
  },
  {
    label: "Volume",
    visible: true,
    key: "param_volume",
    tooltip: "Volume posicionados/parametrizados",
  },
  {
    label: "Resultado",
    visible: true,
    key: "open_pnl",
    tooltip: "Resultado da operação em aberto",
  },
  {
    label: "Acumulado",
    visible: true,
    key: "closed_pnl",
    tooltip: "Resultado acumulado do dia",
  },
  { label: "Status", tooltip: "Status da estratégia", visible: true },
  {
    label: "Perda máx.",
    tooltip: "Ganho máximo diário",
    key: "max_daily_loss",
    visible: true,
    optional: true,
    active: false,
  },
  {
    label: "Ganho máx.",
    tooltip: "Perda máxima diária",
    key: "max_daily_gain",
    visible: true,
    optional: true,
    active: false,
  },
];
